import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageVisit } from '../config/api';

function generateUUID() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback for environments without Web Crypto (e.g. jsdom in tests)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function getOrCreateSessionId() {
  let id = sessionStorage.getItem('analytics_session_id');
  if (!id) {
    id = generateUUID();
    sessionStorage.setItem('analytics_session_id', id);
  }
  return id;
}

export default function usePageTracking() {
  const location = useLocation();
  const sessionIdRef = useRef(getOrCreateSessionId());

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;
    trackPageVisit(sessionIdRef.current, location.pathname).catch(() => {});
  }, [location.pathname]);
}
